import { z } from "zod";

export const METADOC_NAME_MAX_LENGTH = 255;

const hasInvalidControlCharacters = (value: string): boolean =>
  Array.from(value).some((char) => {
    const charCode = char.charCodeAt(0);
    return charCode <= 31 || charCode === 127;
  });

/*
 * validates metadoc name inputs across clone and rename flows.
 */
export const metadocNameSchema = z
  .string()
  .trim()
  .min(1, "Name cannot be empty")
  .max(
    METADOC_NAME_MAX_LENGTH,
    `Name cannot exceed ${METADOC_NAME_MAX_LENGTH} characters`,
  )
  .refine(
    (value) => !hasInvalidControlCharacters(value),
    "Name contains invalid characters",
  );
